import React, { Component } from 'react'
import './social.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook,faGoogle,faInstagram,faTwitter,faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faCoffee, } from '@fortawesome/free-solid-svg-icons'

// library.add(faFacebookF); 

export default class Social extends Component {
    render() {
        return (
            <div className="middle">
        <a className="btn" onClick={()=>window.open("https://www.facebook.com/arriba.mobi/")} href='#'>
            <i ><FontAwesomeIcon  icon={faFacebook} /></i>
        </a>
        {/* <a className="btn" href="#">
                <i><FontAwesomeIcon style={{zIndex:1000}} icon={faGoogle} /></i>
            </a> */}
            <a className="btn" onClick={()=>window.open("https://www.instagram.com/arriba.mobi/")} href="#">
                    <i><FontAwesomeIcon style={{zIndex:1000}} icon={faInstagram} /></i>
                </a>
                {/* <a className="btn" href="#">
                <i><FontAwesomeIcon style={{zIndex:1000}} icon={faYoutube} /></i>
                    </a> */}
                    {/* <a className="btn" href="#">
                    <i><FontAwesomeIcon style={{zIndex:1000}} icon={faTwitter} /></i>
                        </a> */}
    </div>
        )
    }
}
